export default __webpack_public_path__ + "static/media/momenta-vertical-logo.2a36b32e.svg";